import dayjs from 'dayjs';
import localeTH from 'dayjs/locale/th';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';
import updateLocale from 'dayjs/plugin/updateLocale';

dayjs.locale(localeTH);
dayjs.extend(relativeTime);
dayjs.extend(updateLocale);
dayjs.extend(duration);

dayjs.updateLocale('th', {
  relativeTime: {
    future: 'อีก %s',
    past: '%sที่แล้ว',
    s: 'ไม่กี่วินาที',
    m: '1 นาที',
    mm: '%d นาที',
    h: '1 ชั่วโมง',
    hh: '%d ชั่วโมง',
    d: '1 วัน',
    dd: '%d วัน',
    M: '1 เดือน',
    MM: '%d เดือน',
    y: '1 ปี',
    yy: '%d ปี',
  },
});

class DateTimeHelper {
  private iDayjs: dayjs.Dayjs;
  private lang: string;

  constructor() {
    this.iDayjs = dayjs();
    this.iDayjs.locale('th');
    this.lang = 'th';
  }

  getHumanizeDiff(dateTime: dayjs.ConfigType, dateFormated = 'MMMM D, YYYY') {
    if (dayjs.duration(dayjs().diff(dateTime)).days() < 7) {
      return this.iDayjs.to(dateTime);
    } else {
      return dayjs(dateTime).locale(this.lang).format(dateFormated);
    }
  }

  getCustomDateTime(
    dateTime: dayjs.ConfigType,
    dateFormated = 'MMMM DD, YYYY / HH:mm',
  ) {
    return dayjs(dateTime).locale(this.lang).format(dateFormated);
  }
}

export default new DateTimeHelper();
